"use client";

import AuthLayout from "../_components/context/auth-layout";
import { Toaster } from "@/components/ui/toaster";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/nav/app-sidebar";
import { Header } from "@/components/nav/header";
import { AnnouncementBanner } from "@/components/nav/announcement-banner";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function BaseLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthLayout>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SidebarProvider>
          {/* Your shadcn sidebar that supports collapsible="icon" */}
          <AppSidebar />

          {/* This handles the left padding when expanded vs collapsed */}
          <SidebarInset className="min-h-svh flex flex-col bg-gray-50">
            <AnnouncementBanner />
            <Header />

            <main className="flex-1 min-w-0 px-3 py-3 md:px-6 md:py-4">
              {children}
            </main>
            <Toaster />
          </SidebarInset>
        </SidebarProvider>
      </LocalizationProvider>
    </AuthLayout>
  );
}
